import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  getViolationsService,
  getViolationService,
  deleteViolationService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const violationAdminContext = createContext({
  codes: [],
  setCodes: () => {},
  violation: {},
  setViolation: () => {},
  search: "",
  setSearch: () => {},
  to_date: "",
  setTo_date: () => {},
  from_date: "",
  setFrom_date: () => {},
  status: "",
  setStatus: () => {},
  isShowAdvancedSearch: null,
  setIsShowAdvancedSearch: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  limit: null,
  setLimit: () => {},
  handleCloseViolationModal: () => {},
  handleGetViolations: () => {},
  handleGetViolation: () => {},
  handleDeleteViolation: () => {},
  handleDateRange: () => {},
});

const ViolationAdminContext = ({ children, isPenalty }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [violations, setViolations] = useState([]);
  const [violation, setViolation] = useState({});
  const [search, setSearch] = useState("");
  const [to_date, setTo_date] = useState("");
  const [from_date, setFrom_date] = useState("");
  const [status, setStatus] = useState(isPenalty ? "" : "False");
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);
  const [isShowAdvancedSearch, setIsShowAdvancedSearch] = useState(false);

  // Handle Close Payment Transaction Modal
  const handleCloseViolationModal = () => {
    setViolation({});
  };

  // Handle Get Violations Method
  const handleGetViolations = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    let from_dateVal = isEmpty(from_date) ? null : from_date?.split("T")[0];
    let to_dateVal = isEmpty(to_date) ? null : to_date?.split("T")[0];

    const objData = {
      search,
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
      ...(isPenalty && { penalty: 0 }),
      ...(status && { status }),
      ...(to_dateVal && { to_date: `${to_dateVal} 23:59:59` }),
      ...(from_dateVal && { from_date: `${from_dateVal} 00:00:00` }),
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getViolationsService(objData);
      if (status === 200) {
        setViolations(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get Payment Transaction Method
  const handleGetViolation = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getViolationService(id);
      if (status === 200) {
        setViolation(data);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete Payment Transaction Method
  const handleDeleteViolation = async (item) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteViolationService(item?.id);
      if (status === 200) {
        toastSuccessMessage(
          `تخلف ${item?.client?.first_name} ${item?.client?.last_name} با موفقیت حذف شد`
        );
        handleGetViolations();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Date Range
  const handleDateRange = (days) => {
    const today = new Date();
    const fromDate = new Date(today);
    fromDate.setDate(today.getDate() - days);
    setFrom_date(fromDate.toISOString().slice(0, 10));
    setTo_date(today.toISOString().slice(0, 10));
  };

  return (
    <violationAdminContext.Provider
      value={{
        violations,
        setViolations,
        violation,
        setViolation,
        search,
        setSearch,
        to_date,
        setTo_date,
        from_date,
        setFrom_date,
        status,
        setStatus,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        isShowAdvancedSearch,
        setIsShowAdvancedSearch,
        handleCloseViolationModal,
        handleGetViolations,
        handleGetViolation,
        handleDeleteViolation,
        handleDateRange,
      }}
    >
      {children}
    </violationAdminContext.Provider>
  );
};

export default ViolationAdminContext;
